export default __webpack_public_path__ + "static/media/image_for_mobile.f6458a4f.png";